module.exports = __webpack_public_path__ + "media/images/front/icon_twitter-83b7e996b6bdac04c1b23242317dc066.png";